var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-chart',{key:_vm.chartKey,staticClass:"oscillography-alarm-chart",style:({ height: _vm.chartHeight }),attrs:{"autoresize":"","options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }